module.exports = __webpack_public_path__ + "img/slide2.7175ba0c.png";